import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { LazyImgDirective } from '../shared/directives/lazy-img-directive.directive';
import { isBukAdminUser } from '../core/guards/buk-admin.guard';
import { ToolsService } from '../core/services/tools.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [LazyImgDirective, RouterLink, RouterLinkActive, RouterOutlet],
    standalone: true
})
export class AdminComponent implements OnInit {
  menuOpen = false;

  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private toolsService = inject(ToolsService);

  constructor() {}

  ngOnInit(): void {
    // After SSR hydration, enforce admin access from localStorage (guard cannot on the server).
    if (!isPlatformBrowser(this.platformId) || !this.toolsService.localStorageSupport()) {
      return;
    }

    const raw = localStorage?.getItem('currentUser');
    let user = null;
    try {
      user = raw ? JSON.parse(raw) : null;
    } catch (_err) {
      user = null;
    }

    if (!isBukAdminUser(user)) {
      // Prefer /login over / — GuestGuard sends logged-in non-admins from / to /dashboard.
      void this.router.navigate(['/login']);
    }
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }
}
